"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var processor_1 = require("./js/src/processor");
Object.defineProperty(exports, "SchemaProcessor", { enumerable: true, get: function () { return processor_1.SchemaProcessor; } });
//# sourceMappingURL=index.js.map